import React, {FC} from 'react'
import {useField} from 'formik'
import {useIntl} from 'react-intl'
import {AnimaDireita2} from '../../../../../../../../_metronic/assets/animation/styles'

const Step2: FC = () => {
  // const animatedComponents = makeAnimated()
  const intl = useIntl()
  const [fieldMeasurement, ,] = useField('measurement')
  const [fieldPayDay, ,] = useField('payday')
  const [fieldPaymentMonth, ,] = useField('payment_month')
  const [fieldStartContract, ,] = useField('start_contract')
  const [fieldExpirationContract, ,] = useField('expiration_contract')
  const [fieldEffectiveDays, ,] = useField('effective_days')
  const [fieldSigned, ,] = useField('signed')

  console.log('teste ASSINADO', fieldSigned)

  return (
    <div className='w-100'>
      <AnimaDireita2>
        <div className='mb-10'>
          <h2 className='fw-bolder text-dark'>
            {intl.formatMessage({id: 'LICENSES.TITLE_STEAP2'})}
          </h2>
          <div className='text-gray-400 fw-bold fs-6'>
            {intl.formatMessage({id: 'CONTRACTS.SUBTITLE_STEAP2'})}
          </div>
        </div>

        <div className='card-body  p-0 '>
          {/* inicio da primeira linha */}
          <div className='row'>
            <div className='col-lg-6'>
              <label className='form-label fs-6 fw-bold required'>
                {intl.formatMessage({id: 'CONTRACTS.START_DATE'})}
              </label>
              <div className='d-flex align-items-center position-relative my-1'>
                <input
                  type='date'
                  className='form-control form-control-solid  ps-6'
                  {...fieldStartContract}
                />
              </div>
            </div>

            <div className='col-lg-6'>
              <label className='form-label fs-6 fw-bold required'>
                {intl.formatMessage({id: 'CONTRACTS.EXPIRATION_DATE'})}
              </label>
              <div className='d-flex align-items-center position-relative my-1'>
                <input
                  type='date'
                  className='form-control form-control-solid  ps-6'
                  {...fieldExpirationContract}
                />
              </div>
            </div>
          </div>

          {/* fim da primeira linha */}

          {/* inicio da segunda linha */}
          <div className='row mt-3'>
            <div className='col-lg-6'>
              <label className='form-label fs-6 fw-bold'>
                {intl.formatMessage({id: 'CONTRACTS.MEASUREMENT'})}
              </label>
              <div className='d-flex align-items-center position-relative my-1'>
                <select
                  className='form-select form-select-solid ps-6'
                  data-kt-select2='true'
                  {...fieldMeasurement}
                  //onChange={(e) => setstatus(e.target.value)}
                >
                  <option value='' disabled selected hidden>
                    {intl.formatMessage({id: 'CONTRACTS.MEASUREMENT'})}
                  </option>
                  <option value='monthly'>
                    {intl.formatMessage({id: 'CONTRACTS.MEASUREMENT_MONTHLY'})}
                  </option>
                  <option value='yearly'>
                    {intl.formatMessage({id: 'CONTRACTS.MEASUREMENT_YEARLY'})}
                  </option>
                  <option value='punctually'>
                    {intl.formatMessage({id: 'CONTRACTS.MEASUREMENT_PUNCTUALLY'})}
                  </option>
                  <option value='yearly_monthly'>
                    {intl.formatMessage({id: 'CONTRACTS.MEASUREMENT_YEARLY_MONTHLY'})}
                  </option>
                  <option value='free'>
                    {intl.formatMessage({id: 'CONTRACTS.MEASUREMENT_FREE'})}
                  </option>
                  <option value='not_specified'>
                    {intl.formatMessage({id: 'CONTRACTS.MEASUREMENT_NOT_SPECIFIED'})}
                  </option>
                </select>
              </div>
            </div>

            <div className='col-lg-6'>
              <label className='form-label fs-6 fw-bold'>
                {intl.formatMessage({id: 'CONTRACTS.PAYMENT_DATE'})}
              </label>
              <div className='row'>
                <div className='col-lg-5'>
                  <div className='d-flex align-items-center position-relative my-1'>
                    {fieldMeasurement.value === 'free' ? (
                      <input
                        disabled={true}
                        type='number'
                        placeholder={intl.formatMessage({id: 'CONTRACTS.DAY'})}
                        className='form-control form-control-solid bg-secondary  ps-6  '
                        {...fieldPayDay}
                      />
                    ) : (
                      <input
                        type='number'
                        placeholder={intl.formatMessage({id: 'CONTRACTS.DAY'})}
                        className='form-control form-control-solid  ps-6'
                        // className='form-control form-control-solid bg-secondary  ps-6  '
                        {...fieldPayDay}
                      />
                    )}
                  </div>
                </div>
                <div className='col-lg-7'>
                  <div className='d-flex align-items-center position-relative my-1'>
                    {fieldMeasurement.value === 'monthly' || fieldMeasurement.value === 'free' ? (
                      <select
                        className='form-control form-control-solid bg-secondary  ps-6'
                        data-kt-select2='true'
                        disabled={true}
                        {...fieldPaymentMonth}
                      >
                        <option value=''>{intl.formatMessage({id: 'CONTRACTS.MONTH'})}</option>
                      </select>
                    ) : (
                      <select
                        className='form-select form-select-solid ps-6'
                        data-kt-select2='true'
                        {...fieldPaymentMonth}
                      >
                        <option value='' disabled selected hidden>
                          {intl.formatMessage({id: 'CONTRACTS.MONTH'})}
                        </option>
                        <option value='1'>{intl.formatMessage({id: 'COMMON.JANUARY'})}</option>

                        <option value='2'>{intl.formatMessage({id: 'COMMON.FEBRUARY'})}</option>

                        <option value='3'>{intl.formatMessage({id: 'COMMON.MARCH'})}</option>

                        <option value='4'>{intl.formatMessage({id: 'COMMON.APRIL'})}</option>

                        <option value='5'>{intl.formatMessage({id: 'COMMON.MAY'})}</option>

                        <option value='6'>{intl.formatMessage({id: 'COMMON.JUNE'})}</option>

                        <option value='7'>{intl.formatMessage({id: 'COMMON.JULY'})}</option>

                        <option value='8'>{intl.formatMessage({id: 'COMMON.AUGUST'})}</option>

                        <option value='9'>{intl.formatMessage({id: 'COMMON.SEPTEMBER'})}</option>

                        <option value='10'>{intl.formatMessage({id: 'COMMON.OCTOBER'})}</option>

                        <option value='11'>{intl.formatMessage({id: 'COMMON.NOVEMBER'})}</option>

                        <option value='12'>{intl.formatMessage({id: 'COMMON.DECEMBER'})}</option>
                      </select>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* fim da segunda linha */}

          {/* inicio da terceira linha */}
          <div className='row mt-3'>
            <div className='col-lg-6'>
              <label className='form-label fs-6 fw-bold required'>
                {intl.formatMessage({id: 'CONTRACTS.EFFECTIVE_DAYS'})}
              </label>
              <div className='d-flex align-items-center position-relative my-1'>
                <input
                  type='number'
                  className='form-control form-control-solid  ps-6'
                  {...fieldEffectiveDays}
                />
              </div>
            </div>

            <div className='col-lg-6'>
              <label className='form-label fs-6 fw-bold required'>
                {intl.formatMessage({id: 'CONTRACTS.SIGNED'})}
              </label>
              <div className='form-check form-switch form-check-custom form-check-solid fw-bold me-10 px-2'>
                <label className='form-check-label px-2'>
                  {intl.formatMessage({id: 'COMMON.NO'})}
                </label>
                <input
                  className='form-check-input w-45px h-30px'
                  type='checkbox'
                  checked={fieldSigned.value}
                  {...fieldSigned}
                />
                <label className='form-check-label  px-1'>
                  {intl.formatMessage({id: 'COMMON.YES'})}
                </label>
              </div>
            </div>
          </div>

          {/* fim da terceira linha */}
        </div>
      </AnimaDireita2>
    </div>
  )
}

export {Step2}
